import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IReportQueryOptions, IReportStructureStates, IReportStructureStatesResponse } from '../types';
import { REPORT_STRUCTURE_STATES_API_URL, REPORT_STRUCTURE_STATES_QUERY } from '../constants';

export default function useReportStructureStatesQuery(
  options: Ref<IReportQueryOptions>,
  isStructureStatesAllowed: Ref<boolean>,
): IContextQueryResult<IReportStructureStatesResponse, Error, IReportStructureStates> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [REPORT_STRUCTURE_STATES_QUERY, options],
    queryFn: ({ signal }) => fetchGet<IReportStructureStatesResponse>(REPORT_STRUCTURE_STATES_API_URL, {
      signal,
      urlParams: {
        reportType: options.value.reportType,
      },
      permission: options.value.permission,
    }),
    enabled: isStructureStatesAllowed,
    select: (data) => data.stucture_states,
  });
}
